// extracted by mini-css-extract-plugin
module.exports = {"container":"FactCheckBadge_container__gw06v","text":"FactCheckBadge_text__UM45r","checkCircle":"FactCheckBadge_checkCircle__T4zIt"};